/**
 * SkeletonBlock — one grey shimmering placeholder, for page skeletons shown
 * while a page's data loads (Instance Advice, an opened portfolio on Manage
 * Portfolio). Size and shape come from the caller's class.
 *
 * The shimmer is the library's own `amd-sk` class — the same the shared
 * Table's loading rows use — so every loading state in the app looks alike.
 * Decorative: the page's loading region carries the words for screen readers
 * (role="status" + a sr-only sentence).
 */
import { cx } from '@lib/classNames';

import styles from './Skeleton.module.css';

export function SkeletonBlock({ className }) {
  return <span className={cx('amd-sk', styles.block, className)} aria-hidden="true" />;
}

export default SkeletonBlock;
